/**
 * isNullOrUndefined
 */

export const isNullOrUndefined = (v: unknown) => v === null || v === undefined;

/**
 * isNullOrUndefined
 */

export const isNotNullOrUndefined = (v: unknown) => v !== null && v !== undefined;

/**
 * isValidId
 */

export const isValidId = (v: unknown) => v !== null && v !== undefined && v !== 0;

/**
 * normalizeFileName
 */

export const normalizeFileName = (filename: string | undefined | null, maxSize: number): string => {
  if (filename === null || filename === undefined) return "";
  if (filename.length > maxSize) {
    const extIndex = filename.lastIndexOf(".");
    const ext = filename.substring(extIndex + 1);

    const normalizedFilename = filename.substring(0, maxSize - (ext.length + 4));

    return `${normalizedFilename}...(.${ext})`;
  } else {
    return filename;
  }
}

/**
 * normalizeExtensionFile
 */

export const normalizeExtensionFile = (file?: File | null) => {
  if (!file?.name) return undefined;
  const parts = file.name.split(".");
  return parts.length > 1 ? parts.pop()?.toLowerCase() : undefined;
};



export const uploadFileToBase64String = (file: File): Promise<string> => {
  return new Promise<string>((accept, reject) => {
    const reader = new FileReader();

    reader.onloadend = async () => {
      if (typeof reader.result === 'string') {
        try {
          if (reader.result.includes("data:")) {
            accept(reader.result.split(',')[1]);
          } else {
            accept(reader.result);
          }
        } catch (e: unknown) {
          reject("Falha ao salvar imagem!");
        } finally {

        }
      } else {
        reject("Falha ao salvar imagem!");
      }
    };

    reader.readAsDataURL(file);
  });
}

export const uploadFileToBase64StringValid = (file: File | string | null | undefined): Promise<string> => {
  if (!file) {
    return Promise.resolve("");
  }

  // 2. VERIFICAÇÃO: Se já for uma string (Base64), não converte
  if (typeof file === 'string') {
    // Mantemos a mesma lógica de limpar o prefixo "data:image..." se ele existir
    if (file.includes("data:") && file.includes(",")) {
        return Promise.resolve(file.split(',')[1]);
    }
    // Se for string pura sem prefixo, retorna ela mesma
    return Promise.resolve(file);
  }

  // 3. Se for um objeto File/Blob, prossegue com a conversão
  return new Promise<string>((accept, reject) => {
    if (!(file instanceof Blob)) {
        reject("O objeto fornecido não é um arquivo válido.");
        return;
    }

    const reader = new FileReader();

    reader.onloadend = async () => {
      if (typeof reader.result === 'string') {
        try {
          if (reader.result.includes("data:")) {
            accept(reader.result.split(',')[1]);
          } else {
            accept(reader.result);
          }
        } catch (e: unknown) {
          reject("Falha ao processar o resultado da imagem!");
        }
      } else {
        reject("Falha ao salvar imagem!");
      }
    };

    reader.onerror = () => {
        reject("Erro ao ler o arquivo.");
    };

    reader.readAsDataURL(file);
  });
};